// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddProviderController from "./add_provider_controller.js"
application.register("add-provider", AddProviderController)

import AdminController from "./admin_controller.js"
application.register("admin", AdminController)

import AutoautosubmitController from "./autosubmit.js"
application.register("autosubmit", AutoautosubmitController)

import DragController from "./drag_controller.js"
application.register("drag", DragController)

import FlowOrderController from "./flow_order_controller.js"
application.register("flow-order", FlowOrderController)

import ExpandRowsController from "./expand_rows_controller.js"
application.register("expand-rows", ExpandRowsController)

import FilterTasksController from "./filter_tasks_controller.js"
application.register("filter-tasks", FilterTasksController)

import HelloController from "./hello_controller.js"
application.register("hello", HelloController)

import ProcessFlowsController from "./process_flows_controller.js"
application.register("process-flows", ProcessFlowsController)

import ProvidersController from "./providers_controller.js"
application.register("providers", ProvidersController)

import PushToToolsController from "./push_to_tools_controller.js"
application.register("push-to-tools", PushToToolsController)

import RemovalsController from "./removals_controller.js"
application.register("removals", RemovalsController)

import RemoveProviderController from "./remove_provider_controller.js"
application.register("remove-provider", RemoveProviderController)

import SnQueryFormController from "./sn_query_form_controller.js"
application.register("sn-query-form", SnQueryFormController)

import TasksController from "./tasks_controller.js"
application.register("tasks", TasksController)

import ModalController from "./modal_controller.js"
application.register("modal", ModalController)

import InsightsController from "./insights_controller.js"
application.register("insights", InsightsController)

import UserIntegrationHubspotController from "./user_integration_hubspot_controller.js";
application.register('user-integration-hubspot', UserIntegrationHubspotController)

import HubspotMappingController from "./hubspot_mapping_controller.js";
application.register('hubspot-mapping', HubspotMappingController)

import HubspotConditionController from "./hubspot_condition_controller.js";
application.register('hubspot-condition', HubspotConditionController)

import HubspotTriggerController from "./hubspot_trigger_controller.js";
application.register('hubspot-trigger', HubspotTriggerController)

import HubspotGroupConditionController from "./hubspot_group_condition_controller.js";
application.register('hubspot-condition-group', HubspotGroupConditionController)

import HubspotMappingFieldsController from "./hubspot_mapping_fields_controller.js";
application.register('hubspot-mapping-fields', HubspotMappingFieldsController)

import HubspotRemoveUsedFieldsController from "./hubspot_remove_used_field_controller.js";
application.register('hubspot-remove-used-fields', HubspotRemoveUsedFieldsController)

import IntegrationSearchController from "./integration_search_controller"
application.register("integration-search", IntegrationSearchController)

import ContactsController from './contacts_controller'
application.register('contacts', ContactsController)

import ContactsHubspotFiltersController from './contacts_hubspot_filters_controller'
application.register('contacts-hubspot-filters', ContactsHubspotFiltersController)

import AdminUserAutoSubmitController from "./admin_user_auto_submit_controller"
application.register("admin-user-auto-submit", AdminUserAutoSubmitController)

import AdminUserFlashController from "./admin_user_flash_controller"
application.register("admin-user-flash", AdminUserFlashController)

import MultiValueInputController from "./lead_finder/multi_value_input_controller.js"
application.register("multi-value-input", MultiValueInputController)

import LeadFinderCompletionController from "./lead_finder/lead_finder_completion_controller"
application.register("lead-finder-completion", LeadFinderCompletionController)

import FiltersCountController from "./lead_finder/filters_count_controller.js"
application.register("filters-count", FiltersCountController)

import TotalValuesCountController from "./lead_finder/total_values_count_controller.js"
application.register("total-values-count", TotalValuesCountController)

import RemoveFiltersController from "./lead_finder/remove_filters_controller.js"
application.register("remove-filters", RemoveFiltersController)

import LeadFinderFillRowsController from "./lead_finder/fill_rows_controller.js"
application.register("lead-finder-fill-rows", LeadFinderFillRowsController)

import LoaderController from "./loader_controller.js"
application.register("loader", LoaderController)

import WorkspaceSelectController from './workspace_select_controller'
application.register('workspace-select', WorkspaceSelectController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)


import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import ReloadController from "./reload_controller"
application.register("reload", ReloadController)

import SearchCardsController from "./lead_finder/search_cards_controller.js"
application.register("search-cards", SearchCardsController)

import FilterPrefillController from "./lead_finder/filter_prefill_controller.js"
application.register("filter-prefill", FilterPrefillController)

import FileUploadController from './file_upload_controller'
application.register("file-upload", FileUploadController)

import RefreshQueueController from "./refresh_queue_controller"
application.register("refresh-queue", RefreshQueueController)

import CountUpController from "./count_up_controller"
application.register("count-up", CountUpController)

import ListsFiltersController from "./lists_filters_controller"
application.register("lists-filters", ListsFiltersController)

import StripeCardController from "./stripe_card_controller"
application.register("stripe-card", StripeCardController)
